<template>
    <div class="cpa">
        <Header></Header>
        <iframe id="cpaIframe" :src="this.ifreamSrc" scrolling="no" width="100%" @load="changeFrameHeight" frameborder="0"></iframe>
    </div>
</template>
<script>
import Header from '@/components/header';

export default {
    components: { Header },
    data() {
        return {
            hostName: location.hostname,
            clientHeight: null,
            contentWindow: null,
            ifreamSrc: ""
        }
    },
    created() {
        this.ifreamSrc = `https://${this.hostName}/opp`;
        this.clientHeight = document.documentElement.clientHeight - 50;
    },
    mounted() {
        window.onresize = () => {
            this.changeFrameHeight()
        };
    },
    methods: {
        // 高度变化
        changeFrameHeight() {
            var frm = document.getElementById('cpaIframe');
            frm.height = document.documentElement.clientHeight;
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/views/cpa/cpa.vue